export default "__VITE_ASSET___QoXpMvz__"